import { Entity } from '@backstage/catalog-model';
import { generateAjvJsonSchemaValidator } from '../utils';
import schema from '../schema/SystemPrototypeTemplate.v1alpha1.schema.json';
import { JsonObject } from '@backstage/types';

export interface SystemPrototypeTemplateEntity extends Entity {
  apiVersion: 'witboost.com/v1';
  kind: 'SystemPrototypeTemplate';
  metadata: {
    name: string;
    title: string;
    description: string;
    mesh?: {
      icon?: string;
    };
    tags?: string[];
  };
  spec: {
    owner: string;
    type: string;
    parameters?: JsonObject;
    steps: Array<{
      id: string;
      name: string;
      action: string;
    }>;
    output: {
      links: Array<{
        title: string;
        url?: string;
        icon?: string;
        entityRef?: string;
      }>;
    };
  };
}

export const systemPrototypeTemplateEntityValidator =
  generateAjvJsonSchemaValidator(schema);
